// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import lhypEntity from './entities/lhyp.json';
import lhypMenu from '../pages/lhyp/menu.json';
import lhypFullForm from '../pages/lhyp/forms/full.json';
import lhypContextForm from '../pages/lhyp/forms/context.json';
import lhypMiniForm from '../pages/lhyp/forms/mini.json';
import lhypLookupForm from '../pages/lhyp/forms/lookup.json';
import lhypTableView from '../pages/lhyp/views/table.json';
import lhypStagesView from '../pages/lhyp/views/stages.json';
import lhypCardsView from '../pages/lhyp/views/cards.json';
import lhypInlineView from '../pages/lhyp/views/inline.json';
import lhypBacklogView from '../pages/lhyp/views/backlog.json';
import lhypSplitView from '../pages/lhyp/views/split.json';
import lhypCalendarView from '../pages/lhyp/views/calendar.json';
import lhypDashboardView from '../pages/lhyp/views/dashboard.json';

/** Тип запису «Правова гіпотеза» зі сторінками пакета: меню, форми та подання з pages/lhyp/. */
export const lhypDefinition: IRecordTypeDefinition = {
  ...lhypEntity,
  views: assembleViewSet({
      table: lhypTableView,
      stages: lhypStagesView,
      cards: lhypCardsView,
      inline: lhypInlineView,
      backlog: lhypBacklogView,
      split: lhypSplitView,
      calendar: lhypCalendarView,
      dashboard: lhypDashboardView,
  }),
  form: lhypFullForm,
  forms: { full: lhypFullForm, context: lhypContextForm, mini: lhypMiniForm, lookup: lhypLookupForm },
  menu: lhypMenu,
} as IRecordTypeDefinition;
